import api from "@wallet-manager/node-types/dist/src/access/APIEndpoints/index";
import axios from "./axiosInstance";

const { EPtAssetManagement } = api;

export async function getWalletApproveAllowanceRequest(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    EPtAssetManagement.EndPtWalletApproveAllowanceRequest.getAll,
    input,
  );
}

export async function getWalletApproveAllowanceRequestExport(
  params: any,
  config?: any
) {
  const { pageSize, page, ...rest } = params;

  const payload = { ...rest, limit: pageSize, offset: pageSize * page };

  return await axios.get<never, any>(EPtAssetManagement.EndPtWalletApproveAllowanceRequest.export, {
    params: { ...payload },
    ...config,
  });
}

export async function getWalletApproveAllowanceRequestResubmit(
  data: any
) {
  const url = EPtAssetManagement.EndPtWalletApproveAllowanceRequest.resubmit;
  const payload = {
    ...data,
  };
  return axios.post(url, payload);
}